import { render } from "./TestRoles.vue?vue&type=template&id=5e6a9e51&scoped=true"
import script from "./TestRoles.vue?vue&type=script&lang=js"
export * from "./TestRoles.vue?vue&type=script&lang=js"

import "./TestRoles.vue?vue&type=style&index=0&id=5e6a9e51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e6a9e51"]])

export default __exports__